/**
 * Utilidades para formateo de fechas.
 * En toda la plataforma se usa formato DD-MM-AAAA (día-mes-año), NO MM-DD-AAAA.
 */

/** Convierte Date, Timestamp o string a string DD/MM/AAAA (formato display estándar de la plataforma) */
export const formatFechaDDMMAAAA = (fecha) => {
  if (fecha == null) return '';
  try {
    const date = fecha.toDate ? fecha.toDate() : new Date(fecha);
    if (isNaN(date.getTime())) return '';
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const a = date.getFullYear();
    return `${d}/${m}/${a}`;
  } catch (error) {
    console.error('Error formatFechaDDMMAAAA:', error);
    return '';
  }
};

/**
 * Parsea string en formato DD-MM-AAAA o DD/MM/AAAA a Date.
 * También acepta AAAA-MM-DD (para compatibilidad).
 * @returns {Date|null}
 */
export const parseFechaDDMMAAAA = (str) => {
  if (!str || typeof str !== 'string') return null;
  const s = str.trim().replace(/\//g, '-');
  const parts = s.split('-');
  if (parts.length !== 3) return null;
  let d, m, a;
  if (parts[0].length === 4) {
    a = parseInt(parts[0], 10);
    m = parseInt(parts[1], 10);
    d = parseInt(parts[2], 10);
  } else {
    d = parseInt(parts[0], 10);
    m = parseInt(parts[1], 10);
    a = parseInt(parts[2], 10);
  }
  if (isNaN(d) || isNaN(m) || isNaN(a)) return null;
  if (m < 1 || m > 12 || d < 1 || d > 31) return null;
  const date = new Date(a, m - 1, d);
  if (date.getFullYear() !== a || date.getMonth() !== m - 1 || date.getDate() !== d) return null;
  return date;
};

/** Formatea para <input type="date"> (valor YYYY-MM-DD). Solo si se necesita compatibilidad. */
export const fechaToInputValue = (fecha) => {
  const date = fecha?.toDate ? fecha.toDate() : (fecha ? new Date(fecha) : null);
  if (!date || isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const formatearFecha = (fecha) => {
  if (!fecha) return 'N/A';
  try {
    const date = fecha.toDate ? fecha.toDate() : new Date(fecha);
    if (isNaN(date.getTime())) return 'N/A';
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    return `${d}/${m}/${date.getFullYear()}`;
  } catch (error) {
    console.error('Error formateando fecha:', error);
    return 'N/A';
  }
};

export const formatearFechaCompleta = (fecha) => {
  if (!fecha) return 'N/A';
  try {
    const date = fecha.toDate ? fecha.toDate() : new Date(fecha);
    if (isNaN(date.getTime())) return 'N/A';
    return date.toLocaleString('es-CL', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
    console.error('Error formateando fecha completa:', error);
    return 'N/A';
  }
};
